export const InitialDataTbSetItmGroup = () => {
    return {
        Group_Id: null,
        comp_id: window.localStorage.getItem('company'),
        Group_Code: null,
        Group_Name: null,
        Group_Status: "Y",
        Doc_Type: null
    }
}